export default __webpack_public_path__ + "static/media/kitchen1-768w.900ab2f7.webp";